import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom'; // Zamiana Redirect na Navigate
import {T} from '../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";

const CheckoutPaymentCancel = () => {
    const { t } = useTranslation();

    return (
        <Navigate
            to={{
                pathname: '/checkout',
                state: {
                    errorMessage: t('cartSummary.errorWithMonriPayment'),
                },
            }}
        />
    );
};

export default CheckoutPaymentCancel;